import React, { FunctionComponent } from 'react'
import { SaleAddressModal } from '../address/SaleAddressModal'
import { getFeatureFromCache } from '../../../../../util/feature-cache'
import { FEATURE_SALE_ADDRESS_MODAL_REFACTOR } from '../../../../../constants/wr-features'
import { useSaleAddressModal } from './useSaleAddressModal'

export const SaleAddressModalContainer: FunctionComponent = () => {
  const { state } = useSaleAddressModal()

  // Feature flag check: gate entire new modal system
  const isFeatureEnabled = getFeatureFromCache(
    FEATURE_SALE_ADDRESS_MODAL_REFACTOR
  )

  // When flag is OFF: don't render the new modal (legacy behavior continues)
  if (!isFeatureEnabled || !state.isOpen) {
    return null
  }

  return (
    <SaleAddressModal
      formType={state.formType}
      fulfillmentDetails={state.fulfilmentDetails}
      onClose={state.onClose}
      onSave={state.onSave}
    />
  )
}
